module.exports = __webpack_public_path__ + "img/unity-white.4fbb45d6.svg";